module.exports = __webpack_public_path__ + "img/twitter.1eecb9c0.png";